{
  "checklocations": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "orgDetail": [
        {
          "orgNo": "01",
          "orgName": "敦南中心",
          "orgAddress": "台北市大安區敦化南路二段333號2樓",
          "orgParking": "",
          "orgTransport": "捷運文湖線・六張犁站"
        },
        {
          "orgNo": "02",
          "orgName": "內湖中心",
          "orgAddress": "台北市內湖區瑞光路258巷35號6樓",
          "orgParking": "",
          "orgTransport": "捷運文湖線・港墘站"
        },
        {
          "orgNo": "04",
          "orgName": "新竹中心",
          "orgAddress": "新竹市北區經國路1898號3樓",
          "orgParking": "有停車場",
          "orgTransport": ""
        },
        {
          "orgNo": "05",
          "orgName": "台南中心",
          "orgAddress": "台南市中西區永福路一段185號2樓",
          "orgParking": "有停車場",
          "orgTransport": ""
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "questionnairefields": {
    "success": true,
    "statusCode": "S0000",
    "data": [
      {
        "questionnaireType": "個人病史",
        "questionnaireTypeXCode": "personalhistory",
        "diseaseGroups": [
          {
            "diseaseType": "慢性疾病及癌症",
            "diseaseTypeCode": "chronic_cancer",
            "diseaseOptions": [
              {
                "name": "高血壓",
                "code": "hypertension"
              },
              {
                "name": "糖尿病",
                "code": "diabetes"
              },
              {
                "name": "高血脂",
                "code": "hyperlipidemia"
              },
              {
                "name": "癌症",
                "code": "cancer"
              },
              {
                "name": "乳癌",
                "code": "breast_cancer"
              },
              {
                "name": "肺癌",
                "code": "lung_cancer"
              },
              {
                "name": "腸/大腸癌",
                "code": "colorectal_cancer"
              },
              {
                "name": "卵巢/子宮癌",
                "code": "ovarian_uterine_cancer"
              }
            ]
          },
          {
            "diseaseType": "血管/神經性相關疾病",
            "diseaseTypeCode": "vascular_neuro",
            "diseaseOptions": [
              {
                "name": "心血管疾病",
                "code": "cardiovascular"
              },
              {
                "name": "腦血管疾病",
                "code": "cerebrovascular"
              },
              {
                "name": "失智症",
                "code": "dementia"
              }
            ]
          },
          {
            "diseaseType": "全身性/免疫疾病",
            "diseaseTypeCode": "systemic_immune",
            "diseaseOptions": [
              {
                "name": "自體免疫疾病",
                "code": "autoimmune"
              },
              {
                "name": "甲狀腺疾病",
                "code": "thyroid"
              },
              {
                "name": "貧血",
                "code": "anemia"
              },
              {
                "name": "白血病",
                "code": "leukemia"
              }
            ]
          },
          {
            "diseaseType": "肝膽腸胃相關疾病",
            "diseaseTypeCode": "digestive_renal",
            "diseaseOptions": [
              {
                "name": "慢性肝炎或肝硬化",
                "code": "chronic_hepatitis"
              },
              {
                "name": "腎臟疾病",
                "code": "kidney_disease"
              }
            ]
          },
          {
            "diseaseType": "若您有其他疾病，可直接輸入",
            "diseaseTypeCode": "other",
            "diseaseOptions": []
          }
        ]
      },
      {
        "questionnaireType": "家族病史",
        "questionnaireTypeXCode": "familyhistory",
        "diseaseGroups": [
          {
            "diseaseType": "慢性疾病及癌症",
            "diseaseTypeCode": "chronic_cancer",
            "diseaseOptions": [
              {
                "name": "高血壓",
                "code": "hypertension"
              },
              {
                "name": "糖尿病",
                "code": "diabetes"
              },
              {
                "name": "高血脂",
                "code": "hyperlipidemia"
              },
              {
                "name": "癌症",
                "code": "cancer"
              }
            ]
          },
          {
            "diseaseType": "全身性/免疫疾病",
            "diseaseTypeCode": "systemic_immune",
            "diseaseOptions": [
              {
                "name": "癲癇",
                "code": "epilepsy"
              },
              {
                "name": "過敏",
                "code": "allergy"
              },
              {
                "name": "甲狀腺疾病",
                "code": "thyroid_disease"
              },
              {
                "name": "貧血",
                "code": "anemia"
              },
              {
                "name": "中風",
                "code": "stroke"
              }
            ]
          },
          {
            "diseaseType": "眼耳相關疾病",
            "diseaseTypeCode": "eye_ear_disease",
            "diseaseOptions": [
              {
                "name": "白內障",
                "code": "cataract"
              },
              {
                "name": "青光眼",
                "code": "glaucoma"
              },
              {
                "name": "黃斑部病變",
                "code": "macular_degeneration"
              },
              {
                "name": "中耳炎",
                "code": "otitis_media"
              },
              {
                "name": "聽力障礙",
                "code": "hearing_loss"
              }
            ]
          },
          {
            "diseaseType": "心血管相關疾病",
            "diseaseTypeCode": "cardiovascular_disease",
            "diseaseOptions": [
              {
                "name": "心臟病",
                "code": "heart_disease"
              },
              {
                "name": "中風",
                "code": "stroke"
              },
              {
                "name": "慢性氣管炎",
                "code": "chronic_asthma"
              },
              {
                "name": "肺氣腫",
                "code": "emphysema"
              },
              {
                "name": "肺結核",
                "code": "tuberculosis"
              }
            ]
          },
          {
            "diseaseType": "肝膽腸胃相關疾病",
            "diseaseTypeCode": "digestive_disease",
            "diseaseOptions": [
              {
                "name": "肝病",
                "code": "liver_disease"
              },
              {
                "name": "脂肪肝",
                "code": "fatty_liver"
              },
              {
                "name": "逆流性食道炎",
                "code": "gerd"
              },
              {
                "name": "消化性潰瘍",
                "code": "peptic_ulcer"
              },
              {
                "name": "胃炎",
                "code": "gastritis"
              }
            ]
          },
          {
            "diseaseType": "外傷相關疾病",
            "diseaseTypeCode": "trauma_disease",
            "diseaseOptions": [
              {
                "name": "骨折",
                "code": "fracture"
              }
            ]
          },
          {
            "diseaseType": "若您有其他疾病，可直接輸入",
            "diseaseTypeCode": "other",
            "diseaseOptions": []
          }
        ]
      },
      {
        "questionnaireType": "自覺症狀",
        "questionnaireTypeXCode": "subjective_symptoms",
        "diseaseGroups": [
          {
            "diseaseType": "頭部",
            "diseaseTypeCode": "head",
            "diseaseOptions": [
              {
                "name": "頭暈",
                "code": "dizziness"
              },
              {
                "name": "頭痛",
                "code": "headache"
              },
              {
                "name": "視力模糊",
                "code": "blurred_vision"
              },
              {
                "name": "咳嗽",
                "code": "cough"
              },
              {
                "name": "咳痰",
                "code": "phlegm"
              },
              {
                "name": "牙齦出血",
                "code": "gum_bleeding"
              },
              {
                "name": "耳鳴",
                "code": "tinnitus"
              },
              {
                "name": "呼吸困難",
                "code": "dyspnea"
              },
              {
                "name": "悶心",
                "code": "chest_tightness"
              }
            ]
          },
          {
            "diseaseType": "胸腹",
            "diseaseTypeCode": "chest_abdomen",
            "diseaseOptions": [
              {
                "name": "胸痛",
                "code": "chest_pain"
              },
              {
                "name": "心悸",
                "code": "palpitations"
              },
              {
                "name": "腹痛",
                "code": "abdominal_pain"
              },
              {
                "name": "胃灼熱",
                "code": "heartburn"
              },
              {
                "name": "脹氣",
                "code": "bloating"
              },
              {
                "name": "黑便",
                "code": "melena"
              },
              {
                "name": "血便",
                "code": "bloody_stool"
              },
              {
                "name": "腹瀉",
                "code": "diarrhea"
              },
              {
                "name": "便祕",
                "code": "constipation"
              }
            ]
          },
          {
            "diseaseType": "四肢",
            "diseaseTypeCode": "limbs",
            "diseaseOptions": [
              {
                "name": "上肢痛",
                "code": "upper_limb_pain"
              },
              {
                "name": "下肢痛",
                "code": "lower_limb_pain"
              },
              {
                "name": "關節疼痛",
                "code": "joint_pain"
              },
              {
                "name": "手腳麻痛",
                "code": "numbness_tingling"
              },
              {
                "name": "手腳肌肉無力",
                "code": "muscle_weakness"
              }
            ]
          },
          {
            "diseaseType": "特殊症狀",
            "diseaseTypeCode": "special_symptoms",
            "diseaseOptions": [
              {
                "name": "其他",
                "code": "other"
              },
              {
                "name": "體重減輕3公斤以上",
                "code": "weight_loss_over_3kg"
              },
              {
                "name": "排尿不適",
                "code": "urination_discomfort"
              },
              {
                "name": "多尿、頻尿",
                "code": "polyuria_frequency"
              }
            ]
          },
          {
            "diseaseType": "其他症狀",
            "diseaseTypeCode": "other_symptoms",
            "diseaseOptions": []
          }
        ]
      }
    ],
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "userplanresult": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "riskItems": ["血管健康", "代謝功能", "消化道狀況"],
      "allCheckup": {
        "price": "75300",
        "abnormalCnt": "26",
        "potentialCnt": "2",
        "standardCnt": "51",
        "packageList": [
          {
            "deptName": "心血管及代謝系統",
            "deptEName": "Cardiovascular and Metabolic System",
            "examItemList": [
              {
                "examName": "十年心血管疾病風險評估",
                "examItem": "R401470005",
                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                "examType": "潛在疾病風險檢查建議",
                "examPrice": "1000",
                "isChecked": true
              },
              {
                "examName": "同半胱氨酸",
                "examItem": "R401470006",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examType": "潛在疾病風險檢查建議",
                "examPrice": "1000",
                "isChecked": true
              },
              {
                "examName": "心肌旋轉蛋白",
                "examItem": "R401470007",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examType": "潛在疾病風險檢查建議",
                "examPrice": "1000",
                "isChecked": true
              },
              {
                "examName": "甲狀腺球蛋白",
                "examItem": "R401470008",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examType": "潛在疾病風險檢查建議",
                "examPrice": "1000",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "眼科檢查",
            "deptEName": "Eye Examination",
            "examItemList": [
              {
                "examName": "眼底斷層掃描",
                "examItem": "PE000001A",
                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "一般檢查",
            "deptEName": "General Examination",
            "examItemList": [
              {
                "examName": "體脂肪率",
                "examItem": "PE00010019",
                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "身體質量指數",
                "examItem": "PE00010006",
                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "腰圍",
                "examItem": "PE00010017",
                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "血壓",
                "examItem": "PE00010009A",
                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "影像醫學",
            "deptEName": "Image Examination",
            "examItemList": [
              {
                "examName": "骨盆腔核磁共振",
                "examItem": "PE000001C",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "腰薦椎磁振造影",
                "examItem": "PE000002C",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "腦部&腦頸動脈磁振造影",
                "examItem": "PE000003C",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "上腹部核磁共振",
                "examItem": "PE000004C",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": " 感染及其他",
            "deptEName": "Infections And Other",
            "examItemList": [
              {
                "examName": "麻醉(套檢)",
                "examItem": "PE001000",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "大腸鏡(切片)",
                "examItem": "LB000401K",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          }
        ]
      },
      "aiExclusive": {
        "price": "15300",
        "abnormalCnt": "22",
        "potentialCnt": "2",
        "standardCnt": "51",
        "packageList": [
          {
            "deptName": "心血管及代謝系統",
            "deptEName": "Cardiovascular and Metabolic System",
            "examItemList": [
              {
                "examName": "十年心血管疾病風險評估",
                "examItem": "R401470005",
                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                "examPrice": "3000",
                "examType": "潛在疾病風險檢查建議",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "眼科檢查",
            "deptEName": "Eye Examination",
            "examItemList": [
              {
                "examName": "眼底斷層掃描",
                "examItem": "PE000001A",
                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                "examPrice": "4000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "一般檢查",
            "deptEName": "General Examination",
            "examItemList": [
              {
                "examName": "體脂肪率",
                "examItem": "PE00010019",
                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "身體質量指數",
                "examItem": "PE00010006",
                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "腰圍",
                "examItem": "PE00010017",
                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "血壓",
                "examItem": "PE00010009A",
                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "感染及其他",
            "deptEName": "Infections And Other",
            "examItemList": [
              {
                "examName": "麻醉(套檢)",
                "examItem": "PE001000",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "大腸鏡(切片)",
                "examItem": "LB000401K",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          }
        ]
      },
      "basicCheckup": {
        "price": "8500",
        "abnormalCnt": "0",
        "potentialCnt": "0",
        "standardCnt": "51",
        "packageList": [
          {
            "deptName": "一般檢查",
            "deptEName": "General Examination",
            "examItemList": [
              {
                "examName": "體脂肪率",
                "examItem": "PE00010019",
                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "身體質量指數",
                "examItem": "PE00010006",
                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "腰圍",
                "examItem": "PE00010017",
                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "血壓",
                "examItem": "PE00010009A",
                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              }
            ]
          }
        ]
      }
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "checksuggestionsbundle": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "abnormalDetail": [
        {
          "deptName": "消化系統",
          "deptEName": "Digestive System",
          "examInfos": [
            {
              "examName": "胃蛋白酶原",
              "examItem": "L004400A",
              "examMemo": "胃蛋白酶原是評估胃黏膜分泌功能，異常可能暗示胃潰瘍或胃癌風險。檢查胃蛋白酶原有助於早期發現胃部疾病。",
              "price": "3000",
              "mutexInfos": ["L2001900"]
            },
            {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "price": "3500",
              "mutexInfos": ["L004400A"]
            }
          ]
        }
      ],
      "potentialDetail": [
        {
          "deptName": "心血管及代謝系統",
          "deptEName": "Cardiovascular and Metabolic System",
          "examInfos": [
            {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "price": "1200",
              "mutexInfos": []
            },
            {
              "examName": "運動心電圖",
              "examItem": "L1001200A",
              "examMemo": "運動心電圖檢查可評估心臟在運動狀態下血壓與心電圖的變化，評估心臟是否有缺氧、心絞痛或心律不整的情形。",
              "price": "1000",
              "mutexInfos": []
            }
          ]
        }
      ],
      "bodyInsightDetail": [
        {
          "deptName": "眼科檢查",
          "deptEName": "Eye Examination",
          "examInfos": [
            {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "price": "1200",
              "mutexInfos": ["PE000001A", "R2027000A"]
            },
            {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "price": "1000",
              "mutexInfos": []
            }
          ]
        }
      ],
      "addExamDetail": [
        {
          "deptName": "熱門檢項",
          "deptEName": "Trending Examination",
          "examInfos": [
            {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "price": "300",
              "mutexInfos": []
            },
            {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "price": "500",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "一般檢查",
          "deptEName": "General Examination",
          "examInfos": [
            {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "price": "300",
              "mutexInfos": []
            },
            {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "price": "500",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "腫瘤標記",
          "deptEName": "Tumor Biomarker",
          "examInfos": [
            {
              "examName": "前列腺特異抗原",
              "examItem": "LI004600",
              "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
              "examType": "",
              "price": "1500",
              "mutexInfos": []
            },
            {
              "examName": "腫瘤組織多胜脢抗原",
              "examItem": "LI005600",
              "examMemo": "腫瘤組織多胜脢抗原（TPA）是上皮細胞腫瘤的標記。",
              "examType": "",
              "price": "1800",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "心血管及代謝系統",
          "deptEName": "Cardiovascular and Metabolic System",
          "examInfos": [
            {
              "examName": "甲狀腺球蛋白",
              "examItem": "R401470008",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "1000",
              "mutexInfos": []
            },
            {
              "examName": "十年心血管疾病風險評估",
              "examItem": "R401470005",
              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
              "examType": "",
              "price": "1000",
              "mutexInfos": []
            },
            {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "examType": "",
              "price": "1200",
              "mutexInfos": []
            },
            {
              "examName": "運動心電圖",
              "examItem": "L1001200A",
              "examMemo": "運動心電圖檢查可評估心臟在運動狀態下血壓與心電圖的變化，評估心臟是否有缺氧、心絞痛或心律不整的情形。",
              "examType": "",
              "price": "1000",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "眼科檢查",
          "deptEName": "Eye Examination",
          "examInfos": [
            {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "examType": "",
              "price": "1200",
              "mutexInfos": ["PE000001A", "R2027000A"]
            },
            {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "examType": "",
              "price": "1000",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "影像醫學",
          "deptEName": "Image Examination",
          "examInfos": [
            {
              "examName": "骨盆腔核磁共振",
              "examItem": "PE000001C",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "2000",
              "mutexInfos": []
            },
            {
              "examName": "腰薦椎磁振造影",
              "examItem": "PE000002C",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "2000",
              "mutexInfos": []
            },
            {
              "examName": "腦部&腦頸動脈磁振造影",
              "examItem": "PE000003C",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "2000",
              "mutexInfos": []
            },
            {
              "examName": "上腹部核磁共振",
              "examItem": "PE000004C",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "2000",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "消化系統",
          "deptEName": "Digestive System",
          "examInfos": [
            {
              "examName": "胃蛋白酶原",
              "examItem": "L004400A",
              "examMemo": "胃蛋白酶原是評估胃黏膜分泌功能，異常可能暗示胃潰瘍或胃癌風險。檢查胃蛋白酶原有助於早期發現胃部疾病。",
              "examType": "",
              "price": "3000",
              "mutexInfos": ["L2001900"]
            },
            {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "examType": "",
              "price": "3500",
              "mutexInfos": ["L004400A"]
            }
          ]
        }
      ]
    },
    "timestamp": "2025-05-07T09:00:00Z"
  },
  "eligibilityquestionnairefields": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "indicationInfos": [
        {
          "questionnaireTypeId": "GI01",
          "questionnaireTypeName": "麻醉",
          "examItem": "PE001000",
          "questionList": [
            {
              "questionId": "001",
              "questionName": "目前已懷孕、可能懷孕，或正在進行生殖醫療",
              "choiceList": [
                {
                  "choiceId": 2,
                  "choiceResult": "Y",
                  "isContinue": false
                },
                {
                  "choiceId": 3,
                  "choiceResult": "N",
                  "isContinue": true
                }
              ]
            },
            {
              "questionId": "002",
              "questionName": "有癲癇病史或目前有癲癇發作",
              "choiceList": [
                {
                  "choiceId": 4,
                  "choiceResult": "Y",
                  "isContinue": false
                },
                {
                  "choiceId": 5,
                  "choiceResult": "N",
                  "isContinue": true
                }
              ]
            },
            {
              "questionId": "003",
              "questionName": "最近有鼻塞或痰多現象",
              "choiceList": [
                {
                  "choiceId": 6,
                  "choiceResult": "Y",
                  "isContinue": false
                },
                {
                  "choiceId": 7,
                  "choiceResult": "N",
                  "isContinue": true
                }
              ]
            }
          ]
        },
        {
          "questionnaireTypeId": "GI02",
          "questionnaireTypeName": "胃鏡、大腸鏡(切片)",
          "examItem": "LB000401K",
          "questionList": [
            {
              "questionId": "004",
              "questionName": "您的 BMI 是否 >= 34",
              "choiceList": [
                {
                  "choiceId": 8,
                  "choiceResult": "Y",
                  "isContinue": false
                },
                {
                  "choiceId": 9,
                  "choiceResult": "N",
                  "isContinue": true
                }
              ]
            }
          ]
        }
      ]
    },
    "timestamp": "2025-05-12T13:00:00Z"
  },
  "checkreminders": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "reminderList": [
        {
          "examNameList": ["大腸鏡"],
          "reminderText": "<ol><li>已知使用保健品，〖魚油、銀杏、紅麴、納豆激酶、人參〗或中藥需停 7 日</li><li>已知如檢查當下發現瘜肉：<ol class='alphabet-list'><li>醫師會評估大小和出血風險高低。</li><li>判斷是否可進行切片或切除術處置，處置瘜肉將送化驗，化驗費用另計。</li><li>如出現無法處置狀況或超過 0.8 公分以上瘜肉，則現場不做切片或切除處置</li></ol></li><li>已知檢查當日切除術者，健檢完兩週內不可搭飛機、不可做核磁共振相關檢查</li><li>已知抽血檢驗:血小板數值須大於 10 萬才能執行切片或切除檢驗</li></ol>"
        },
        {
          "examNameList": ["腦部磁振造影", "頸部磁振造影"],
          "reminderText": "檢查前三天請勿安排上消化道攝影檢查，避免影響檢查。"
        },
        {
          "examNameList": ["水痘抗體IgG"],
          "reminderText": "<ol><li>若得過水痘、帶狀皰疹病史檢查當天請告知現場人員</li><li>若有接種疫苗至少應間隔 4 週後再檢查</li></ol>"
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "checkupsettings": {
    "success": true,

"statusCode": "S0000",

"data": {

"languInfos": [

{

"uno": "1",

"noDesc": "中文"

},

{

"uno": "2",

"noDesc": "英文"

},

{

"uno": "3",

"noDesc": "日文"

}

],

"breakfastInfos": [

{

"uno": "01",

"noDesc": "中式/素食"

},

{

"uno": "02",

"noDesc": "中式/葷食"

},

{

"uno": "03",

"noDesc": "西式/素食"

},

{

"id": "04",

"noDesc": "西式/葷食"

}

],

"lunchInfos": [

{

"uno": "01",

"noDesc": "中式/素食"

},

{

"uno": "02",

"noDesc": "中式/葷食"

},

{

"uno": "03",

"noDesc": "西式/素食"

},

{

"uno": "04",

"noDesc": "西式/葷食"

}

],

"sizeInfos": [

{

"uno": "01",

"noDesc": "M"

},

{

"uno": "02",

"noDesc": "L"

},

{

"uno": "03",

"noDesc": "XL"

},

{

"uno": "04",

"noDesc": "2L"

},

{

"uno": "05",

"noDesc": "3L"

},

{

"uno": "06",

"noDesc": "4L"

},

{

"uno": "07",

"noDesc": "5L"

}

]

},

"timestamp": "2025-04-27T13:00:00Z"
  },
  "availabledates": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "dayType": "2",
      "bookCalInfos": [
        {
          "bookCnt": "10",
          "bookDate": "20250715",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        },
        {
          "bookCnt": "1",
          "bookDate": "20250716",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        },
        {
          "bookCnt": "30",
          "bookDate": "20250717",
          "bookTimes": ["0730", "0815", "0800", "1300"]
        },
        {
          "bookCnt": "27",
          "bookDate": "20250718",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        },
        {
          "bookCnt": "0",
          "bookDate": "20250719",
          "bookTimes": ["0730", "0745", "0800", "1400"]
        },
        {
          "bookCnt": "2",
          "bookDate": "20250720",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        },
        {
          "bookCnt": "3",
          "bookDate": "20250721",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250722",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        },
        {
          "bookCnt": "1",
          "bookDate": "20250723",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        },
        {
          "bookCnt": "30",
          "bookDate": "20250724",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250725",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250726",
          "bookTimes": ["0730", "0745", "0800", "1300"]
        }
      ],
      "nutCalInfos": [
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250715",
          "nutBookTimes": ["0900", "1000", "1100", "1600"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250716",
          "nutBookTimes": ["0900", "1000", "1100", "1600"]
        },
        {
          "nutBookCnt": 1,
          "nutBookDate": "20250717",
          "nutBookTimes": ["0900", "1000", "1100", "1600"]
        },
        {
          "nutBookCnt": 30,
          "nutBookDate": "20250718",
          "nutBookTimes": ["0900", "1000", "1100", "1600"]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250719",
          "nutBookTimes": ["0900", "1000", "1100", "1500"]
        },
        {
          "nutBookCnt": 1,
          "nutBookDate": "20250720",
          "nutBookTimes": ["0900", "1000", "1100", "1500"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250721",
          "nutBookTimes": ["0900", "1000", "1100", "1600"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250722",
          "nutBookTimes": ["0900", "1000", "1100", "1600"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250723",
          "nutBookTimes": ["0900", "1000", "1100", "1600"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250724",
          "nutBookTimes": ["0900", "1000", "1100", "1600"]
        }
      ],
      "imageCalInfos": true
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "confirmappointment": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "caseNo": "250016232"
    },
    "timestamp": "2025-05-13T13:10:00Z"
  },
  "calendar": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "reminders": [
        {
          "date": "2025/04/01",
          "description": ["開始每日攝取足夠的水分，至少1,500~2,000c.c."]
        },
        {
          "date": "2025/04/18",
          "description": [
            "服用清腸藥之前可留取糞便檢體，檢體放冰箱冷藏，冷藏不超過2天",
            "女性若遇生理期，請勿留取檢體"
          ]
        },
        {
          "date": "2025/04/21",
          "description": [
            "低渣飲食開始（不可食用蔬菜、水果和乳製品；若非每日排便，請提前於檢查前 5~6天 低渣）"
          ]
        },
        {
          "date": "2025/04/21",
          "description": [
            "檢查前需空腹至少8小時，女性收集檢體與當日檢查請避開生理期間，若遇生理期，可前往健檢、或於預約紀錄修改健檢日期",
            "報到時請主動告知是否懷孕或備孕，過敏史及用藥情況",
            "報到請準備：<br/>a. 健保卡／身分證或居留證<br/>b. 已完成資料袋內之文件"
          ]
        }
      ]
    },
    "timestamp": "2025-04-27T13:20:00Z"
  },
  "enterpriseplans": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "companyInfo": {
        "companyNo": "50093",
        "companyName": "台灣漢高股份有限公司",
        "bookableDateE": "20250515",
        "sponsorAmt": "2000"
      },
      "packageList": [
        {
          "packageNo": "500930046",
          "packageName": "健康樂活＋心血管＋消化道",
          "dayType": "1",
          "bookPeriod": "1",
          "price": "6600.00000",
          "hasBreakfast": true,
          "hasLunch": false,
          "deptList": [
            {
              "deptName": "潛在疾病風險建議",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010004",
                  "examName": "身體組成分析",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010018",
                  "examName": "糖尿病",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010002",
                  "examName": "高血壓",
                  "examMemo": "了解身體基本資料"
                },
                {
                  "examItem": "PE00010005",
                  "examName": "高血脂",
                  "examMemo": "了解身體基本資料"
                }
              ]
            },
            {
              "deptName": "一般檢查",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010003",
                  "examName": "理想體重",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010017",
                  "examName": "腰圍",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010001",
                  "examName": "身高",
                  "examMemo": "了解身體基本資料"
                }
              ]
            }
          ],
          "examChooseList": [
            {
              "groupTitleName": "2 選 1",
              "groupCount": 2,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R1040300A",
                  "examName": "頸椎X光",
                  "examMemo": "檢查頸椎有無骨刺、滑脫、椎間狹窄等異常"
                },
                {
                  "examItem": "PE00040017B",
                  "examName": "眼科醫師檢查-不含眼壓",
                  "examMemo": "眼科醫師利用眼底鏡及細隙燈，進行眼球內部(包括角膜、前房、瞳孔、水晶體、視網膜、視神經)檢測"
                }
              ]
            }
          ]
        },
        {
          "packageNo": "500930047",
          "packageName": "健康樂活＋心血管＋消化道",
          "dayType": "1",
          "bookPeriod": "1",
          "price": "5500.00000",
          "hasBreakfast": true,
          "hasLunch": false,
          "deptList": [
            {
              "deptName": "一般檢查",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010003",
                  "examName": "理想體重",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010017",
                  "examName": "腰圍",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                }
              ]
            }
          ],
          "examChooseList": [
            {
              "groupTitleName": "2 選 1",
              "groupCount": 2,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R1040300A",
                  "examName": "頸椎X光",
                  "examMemo": "檢查頸椎有無骨刺、滑脫、椎間狹窄等異常"
                },
                {
                  "examItem": "PE00040017B",
                  "examName": "眼科醫師檢查-不含眼壓",
                  "examMemo": "眼科醫師利用眼底鏡及細隙燈，進行眼球內部(包括角膜、前房、瞳孔、水晶體、視網膜、視神經)檢測"
                }
              ]
            },
            {
              "groupTitleName": "3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R4014700A",
                  "examName": "頸動脈超音波",
                  "examMemo": "評估供應腦部血流的頸動脈有無硬化、狹窄等異常"
                },
                {
                  "examItem": "LI005500",
                  "examName": "CA 72-4腫瘤標記",
                  "examMemo": "胃癌篩檢參考指標"
                },
                {
                  "examItem": "L1008000A",
                  "examName": "HRV自律神經",
                  "examMemo": "檢查交感、副交感神經的調控是否異常，了解自律神經的年齡、功能指標及平衡程度，並評估您的情緒、壓力指數"
                }
              ]
            }
          ],
          "groupChooseList": [
            {
              "groupTitleName": "組合 3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "groupList": [
                {
                  "examItemList": [
                    {
                      "examItem": "LI003800",
                      "examName": "CA125腫瘤標記",
                      "examMemo": "女性生殖器癌（如卵巢癌）篩檢參考指標"
                    },
                    {
                      "examItem": "LO010500B",
                      "examName": "(組合)子宮頸抹片檢查(企業)含內診",
                      "examMemo": "篩檢子宮頸細胞有無病變(含內診檢查)"
                    },
                    {
                      "examItem": "T8001000A",
                      "examName": "婦科超音波",
                      "examMemo": "檢查有無子宮或卵巢腫瘤等結構異常"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R1020300A",
                      "examName": "腹部X光及腰薦椎側面X光",
                      "examMemo": "有無腸阻塞、膽結石、泌尿系統結石,評估腰椎、骨盆、髖關節疾病"
                    },
                    {
                      "examItem": "R1140400A",
                      "examName": "左髖關節骨質密度",
                      "examMemo": "瞭解骨質狀況，有無骨質減少或疏鬆情形"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R2030100A",
                      "examName": "乳房超音波",
                      "examMemo": "利用超音波檢查乳房是否異常"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "packageNo": "500930048",
          "packageName": "健康樂活＋心血管＋消化道",
          "dayType": "1",
          "bookPeriod": "1",
          "price": "15000.00000",
          "hasBreakfast": true,
          "hasLunch": false,
          "deptList": [
            {
              "deptName": "一般檢查",
              "deptEName": "General  Examination",
              "examItemList": [

                {
                  "examItem": "PE00010017",
                  "examName": "腰圍",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010001",
                  "examName": "身高",
                  "examMemo": "了解身體基本資料"
                }
              ]
            }
          ],
          "examChooseList": [
            {
              "groupTitleName": "2 選 1",
              "groupCount": 2,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R1040300A",
                  "examName": "頸椎X光",
                  "examMemo": "檢查頸椎有無骨刺、滑脫、椎間狹窄等異常"
                },
                {
                  "examItem": "PE00040017B",
                  "examName": "眼科醫師檢查-不含眼壓",
                  "examMemo": "眼科醫師利用眼底鏡及細隙燈，進行眼球內部(包括角膜、前房、瞳孔、水晶體、視網膜、視神經)檢測"
                }
              ]
            },
            {
              "groupTitleName": "3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R4014700A",
                  "examName": "頸動脈超音波",
                  "examMemo": "評估供應腦部血流的頸動脈有無硬化、狹窄等異常"
                },
                {
                  "examItem": "LI005500",
                  "examName": "CA 72-4腫瘤標記",
                  "examMemo": "胃癌篩檢參考指標"
                },
                {
                  "examItem": "L1008000A",
                  "examName": "HRV自律神經",
                  "examMemo": "檢查交感、副交感神經的調控是否異常，了解自律神經的年齡、功能指標及平衡程度，並評估您的情緒、壓力指數"
                }
              ]
            }
          ],
          "groupChooseList": [
            {
              "groupTitleName": "組合 3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "groupList": [
                {
                  "examItemList": [
                    {
                      "examItem": "LI003800",
                      "examName": "CA125腫瘤標記",
                      "examMemo": "女性生殖器癌（如卵巢癌）篩檢參考指標"
                    },
                    {
                      "examItem": "LO010500B",
                      "examName": "(組合)子宮頸抹片檢查(企業)含內診",
                      "examMemo": "篩檢子宮頸細胞有無病變(含內診檢查)"
                    },
                    {
                      "examItem": "T8001000A",
                      "examName": "婦科超音波",
                      "examMemo": "檢查有無子宮或卵巢腫瘤等結構異常"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R1020300A",
                      "examName": "腹部X光及腰薦椎側面X光",
                      "examMemo": "有無腸阻塞、膽結石、泌尿系統結石,評估腰椎、骨盆、髖關節疾病"
                    },
                    {
                      "examItem": "R1140400A",
                      "examName": "左髖關節骨質密度",
                      "examMemo": "瞭解骨質狀況，有無骨質減少或疏鬆情形"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R2030100A",
                      "examName": "乳房超音波",
                      "examMemo": "利用超音波檢查乳房是否異常"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "packageNo": "500930099",
          "packageName": "健康樂活＋心血管＋刃牙道",
          "dayType": "1",
          "bookPeriod": "1",
          "price": "8000.00000",
          "hasBreakfast": true,
          "hasLunch": false,
          "deptList": [
            {
              "deptName": "潛在疾病風險建議",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010004",
                  "examName": "身體組成分析",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010018",
                  "examName": "糖尿病",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010002",
                  "examName": "高血壓",
                  "examMemo": "了解身體基本資料"
                },
                {
                  "examItem": "PE00010005",
                  "examName": "高血脂",
                  "examMemo": "了解身體基本資料"
                }
              ]
            },
            {
              "deptName": "一般檢查",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010003",
                  "examName": "理想體重",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010017",
                  "examName": "腰圍",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010001",
                  "examName": "身高",
                  "examMemo": "了解身體基本資料"
                }
              ]
            }
          ],
          "examChooseList": [
            {
              "groupTitleName": "2 選 1",
              "groupCount": 2,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R1040300A",
                  "examName": "頸椎X光",
                  "examMemo": "檢查頸椎有無骨刺、滑脫、椎間狹窄等異常"
                },
                {
                  "examItem": "PE00040017B",
                  "examName": "眼科醫師檢查-不含眼壓",
                  "examMemo": "眼科醫師利用眼底鏡及細隙燈，進行眼球內部(包括角膜、前房、瞳孔、水晶體、視網膜、視神經)檢測"
                }
              ]
            },
            {
              "groupTitleName": "3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R4014700A",
                  "examName": "頸動脈超音波",
                  "examMemo": "評估供應腦部血流的頸動脈有無硬化、狹窄等異常"
                },
                {
                  "examItem": "LI005500",
                  "examName": "CA 72-4腫瘤標記",
                  "examMemo": "胃癌篩檢參考指標"
                },
                {
                  "examItem": "L1008000A",
                  "examName": "HRV自律神經",
                  "examMemo": "檢查交感、副交感神經的調控是否異常，了解自律神經的年齡、功能指標及平衡程度，並評估您的情緒、壓力指數"
                }
              ]
            }
          ],
          "groupChooseList": [
            {
              "groupTitleName": "組合 3 選 2",
              "groupCount": 3,
              "chooseCount": 2,
              "groupList": [
                {
                  "examItemList": [
                    {
                      "examItem": "LI00380U",
                      "examName": "賀爾蒙檢查",
                      "examMemo": "女性生殖器癌（如卵巢癌）篩檢參考指標"
                    },
                    {
                      "examItem": "LO010500B",
                      "examName": "(組合)子宮頸抹片檢查(企業)含內診",
                      "examMemo": "篩檢子宮頸細胞有無病變(含內診檢查)"
                    },
                    {
                      "examItem": "T8001000B",
                      "examName": "大腸鏡",
                      "examMemo": "檢查有無子宮或卵巢腫瘤等結構異常"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R1020300A",
                      "examName": "腹部X光及腰薦椎側面X光",
                      "examMemo": "有無腸阻塞、膽結石、泌尿系統結石,評估腰椎、骨盆、髖關節疾病"
                    },
                    {
                      "examItem": "R1140400A",
                      "examName": "左髖關節骨質密度",
                      "examMemo": "瞭解骨質狀況，有無骨質減少或疏鬆情形"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R2030100A",
                      "examName": "乳房超音波",
                      "examMemo": "利用超音波檢查乳房是否異常"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "compareplans": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "packageDetail": [
        {
          "packageNo": "30145142",
          "packageInfo": [
            {
              "deptName": "一般檢查",
              "deptEName": "General Examination",
              "isGroup": false,
              "groupInfo": [],
              "examInfo": [
                {
                  "examName": "身體組成分析",
                  "examItem": "PE00010040",
                  "isChecked": true
                },
                {
                  "examName": "身高",
                  "examItem": "PE00010001",
                  "isChecked": true
                },
                {
                  "examName": "體重",
                  "examItem": "PE00010002",
                  "isChecked": true
                },
                {
                  "examName": "身體質量指數",
                  "examItem": "PE00010006",
                  "isChecked": true
                },
                {
                  "examName": "理想體重",
                  "examItem": "PE00010003",
                  "isChecked": true
                },
                {
                  "examName": "脈搏",
                  "examItem": "PE00010007A",
                  "isChecked": true
                },
                {
                  "examName": "血壓",
                  "examItem": "PE00010009A",
                  "isChecked": true
                },
                {
                  "examName": "腰圍",
                  "examItem": "PE00010017",
                  "isChecked": true
                }
              ]
            },
            {
              "deptName": "心血管及代謝系統",
              "deptEName": "Cardiovascular and Metabolic System",
              "isGroup": false,
              "groupInfo": [],
              "examInfo": [
                {
                  "examName": "總膽固醇",
                  "examItem": "L3001900",
                  "isChecked": true
                },
                {
                  "examName": "三酸甘油脂",
                  "examItem": "L3002000",
                  "isChecked": true
                }
              ]
            },
            {
              "deptName": "腫瘤標記",
              "deptEName": "Tumor Marker",
              "isGroup": true,
              "groupInfo": [
                {
                  "groupTitleName": "腫瘤二選一",
                  "chooseCnt": 1,
                  "groupList": [
                    {
                      "groupName": "CA199腫瘤標記",
                      "groupItem": "LI004100"
                    },
                    {
                      "groupName": "CA153腫瘤標記",
                      "groupItem": "LI004900"
                    }
                  ]
                },
                {
                  "groupTitleName": "腫瘤三選一",
                  "chooseCnt": 1,
                  "groupList": [
                    {
                      "groupName": "CA199腫瘤標記",
                      "groupItem": "LI004100"
                    },
                    {
                      "groupName": "CA153腫瘤標記",
                      "groupItem": "LI004900"
                    },
                    {
                      "groupName": "CA133腫瘤標記",
                      "groupItem": "LI004901"
                    }
                  ]
                }
              ],
              "examInfo": [
                {
                  "examName": "癌胚胎抗原",
                  "examItem": "LI001600",
                  "isChecked": true
                },
                {
                  "examName": "鱗狀細胞癌抗原",
                  "examItem": "LI005200",
                  "isChecked": true
                }
              ]
            }
          ]
        },
        {
          "packageNo": "30145567",
          "packageInfo": [
            {
              "deptName": "一般檢查",
              "deptEName": "General Examination",
              "isGroup": false,
              "groupInfo": [],
              "examInfo": [
                {
                  "examName": "身體組成分析",
                  "examItem": "PE00010040",
                  "isChecked": true
                },
                {
                  "examName": "身高",
                  "examItem": "PE00010001",
                  "isChecked": true
                },
                {
                  "examName": "體重",
                  "examItem": "PE00010002",
                  "isChecked": true
                },
                {
                  "examName": "身體質量指數",
                  "examItem": "PE00010006",
                  "isChecked": false
                },
                {
                  "examName": "理想體重",
                  "examItem": "PE00010003",
                  "isChecked": true
                },
                {
                  "examName": "脈搏",
                  "examItem": "PE00010007A",
                  "isChecked": false
                },
                {
                  "examName": "血壓",
                  "examItem": "PE00010009A",
                  "isChecked": true
                },
                {
                  "examName": "腰圍",
                  "examItem": "PE00010017",
                  "isChecked": false
                }
              ]
            },
            {
              "deptName": "心血管及代謝系統",
              "deptEName": "Cardiovascular and Metabolic System",
              "isGroup": false,
              "groupInfo": [],
              "examInfo": [
                {
                  "examName": "總膽固醇",
                  "examItem": "L3001900",
                  "isChecked": true
                },
                {
                  "examName": "三酸甘油脂",
                  "examItem": "L3002000",
                  "isChecked": false
                }
              ]
            },
            {
              "deptName": "腫瘤標記",
              "deptEName": "Tumor Marker",
              "isGroup": true,
              "groupInfo": [
                {
                  "groupTitleName": "腫瘤二選一",
                  "chooseCnt": 1,
                  "groupList": [
                    {
                      "groupName": "CA199腫瘤標記",
                      "groupItem": "LI004100"
                    },
                    {
                      "groupName": "CA153腫瘤標記",
                      "groupItem": "LI004900"
                    }
                  ]
                }
              ],
              "examInfo": [
                {
                  "examName": "癌胚胎抗原",
                  "examItem": "LI001600",
                  "isChecked": true
                },
                {
                  "examName": "鱗狀細胞癌抗原",
                  "examItem": "LI005200",
                  "isChecked": true
                }
              ]
            }
          ]
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "enterprisecheckupsettings": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "language": [
        {
          "id": "1",
          "name": "繁體中文"
        },
        {
          "id": "2",
          "name": "英文"
        },
        {
          "id": "3",
          "name": "日文"
        }
      ],
      "breakfast": [
        {
          "id": "01",
          "name": "中式/素食"
        },
        {
          "id": "02",
          "name": "中式/葷食"
        },
        {
          "id": "03",
          "name": "西式/素食"
        },
        {
          "id": "04",
          "name": "西式/葷食"
        }
      ],
      "lunch": [
        {
          "id": "01",
          "name": "中式/素食"
        },
        {
          "id": "02",
          "name": "中式/葷食"
        },
        {
          "id": "03",
          "name": "西式/素食"
        },
        {
          "id": "04",
          "name": "西式/葷食"
        }
      ],
      "clothesSize": [
        {
          "id": "01",
          "name": "M"
        },
        {
          "id": "02",
          "name": "L"
        },
        {
          "id": "03",
          "name": "XL"
        },
        {
          "id": "04",
          "name": "2L"
        },
        {
          "id": "05",
          "name": "3L"
        },
        {
          "id": "06",
          "name": "4L"
        },
        {
          "id": "07",
          "name": "5L"
        }
      ],
      "isContactPickupByAgent": true,
      "isDeliveryPickupByAgent": true
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "corporateavailabledates": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "bookCalInfos": [
        {
          "bookCnt": "27",
          "bookDate": "20250715",
          "bookTimes": ["0730", "0745", "0800"]
        },
        {
          "bookCnt": "22",
          "bookDate": "20250716",
          "bookTimes": ["0730", "0745", "0800"]
        },
        {
          "bookCnt": "1",
          "bookDate": "20250717",
          "bookTimes": ["0730", "0745", "0800", "1400"]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250718",
          "bookTimes": ["0800", "1400"]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250719",
          "bookTimes": ["0800", "1400"]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250720",
          "bookTimes": ["0800", "1400"]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250721",
          "bookTimes": ["0800", "1400"]
        },
        {
          "bookCnt": "2",
          "bookDate": "20250722",
          "bookTimes": ["0800", "1400"]
        },
        {
          "bookCnt": "2",
          "bookDate": "20250723",
          "bookTimes": ["0800", "1400"]
        },
        {
          "bookCnt": "12",
          "bookDate": "20250724",
          "bookTimes": ["0800", "1400"]
        }
      ],
      "nutCalInfos": [
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250715",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250716",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250717",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250718",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250719",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250720",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250721",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 1,
          "nutBookDate": "20250722",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 2,
          "nutBookDate": "20250723",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250724",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250725",
          "nutBookTimes": ["0900", "1000", "1100"]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250726",
          "nutBookTimes": ["0900", "1000", "1100"]
        }
      ],
      "imageCalInfos": true
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "corporateappointments": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "caseNo": "C20250427001"
    },
    "timestamp": "2025-05-13T13:10:00Z"
  },
  "allreports": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "hcreportList": [
        {
          "caseNo": "201234567",
          "bookDate": "20250701",
          "bookStatus": "0"
        },
        {
          "caseNo": "123456789",
          "bookDate": "20250630",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456780",
          "bookDate": "20250629",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234568",
          "bookDate": "20250628",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456781",
          "bookDate": "20250627",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456782",
          "bookDate": "20250626",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234563",
          "bookDate": "20250625",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456784",
          "bookDate": "20250624",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456785",
          "bookDate": "20250623",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234567",
          "bookDate": "20250622",
          "bookStatus": "0"
        },
        {
          "caseNo": "123456789",
          "bookDate": "20250621",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456780",
          "bookDate": "20250620",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234568",
          "bookDate": "20250619",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456781",
          "bookDate": "20250618",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456782",
          "bookDate": "20250617",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234563",
          "bookDate": "20250616",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456784",
          "bookDate": "20250615",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456785",
          "bookDate": "20250614",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234567",
          "bookDate": "20250613",
          "bookStatus": "0"
        },
        {
          "caseNo": "123456789",
          "bookDate": "20250612",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456780",
          "bookDate": "20250611",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234568",
          "bookDate": "20250610",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456781",
          "bookDate": "20250609",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456782",
          "bookDate": "20250608",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234563",
          "bookDate": "20250607",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456784",
          "bookDate": "20250606",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456785",
          "bookDate": "20250605",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234567",
          "bookDate": "20250604",
          "bookStatus": "0"
        },
        {
          "caseNo": "123456789",
          "bookDate": "20250603",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456780",
          "bookDate": "20250602",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234568",
          "bookDate": "20250601",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456781",
          "bookDate": "20250531",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456782",
          "bookDate": "20250530",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234563",
          "bookDate": "20250529",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456784",
          "bookDate": "20250528",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456785",
          "bookDate": "20250527",
          "bookStatus": "1"
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "name": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "name": "王小小"
    },
    "timestamp": "2025-05-28T13:40:00Z"
  },
  "phone": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "cell": "0912345678"
    },
    "timestamp": "2025-05-28T13:40:00Z"
  },
  "email": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "email": "test@email.com"
    },
    "timestamp": "2025-05-28T13:40:00Z"
  },
  "verifycurrentpassword": {
    "success": true,
    "statusCode": "S0000",
    "data": {},
    "timestamp": "2025-04-27T13:40:00Z"
  },
  "changepassword": {
    "success": true,
    "statusCode": "S0000",
    "data": {},
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "appointmenthistory": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "flowCode": "0"
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "plans": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "dataType": "1",
      "isModified": true,
      "isCancel": true,
      "reminders": [
        {
          "date": "2025/04/01",
          "description": ["開始每日攝取足夠的水分，至少1,500~2,000c.c."]
        },
        {
          "date": "2025/04/18",
          "description": [
            "服用清腸藥之前可留取糞便檢體，檢體放冰箱冷藏，冷藏不超過2天",
            "女性若遇生理期，請勿留取檢體"
          ]
        },
        {
          "date": "2025/04/21",
          "description": [
            "檢查前需空腹至少8小時，女性收集檢體與當日檢查請避開生理期間，若遇生理期，可前往健檢、或於預約紀錄修改健檢日期",
            "報到時請主動告知是否懷孕或備孕，過敏史及用藥情況",
            "報到請準備：<br/>a. 健保卡／身分證或居留證<br/>b. 已完成資料袋內之文件"
          ]
        }
      ],
      "reminderGroups": [
        {
          "groupId": "GI05",
          "groupName": "內視鏡檢後提醒",
          "examItem": "LB0002000M",
          "examName": "無痛AI胃腸鏡",
          "reminderInfos": [
            {
              "reminderId": "085",
              "reminderName": "已知檢查當日若有息肉切除，為避免出血，健檢完兩週內不可搭乘飛機"
            },
            {
              "reminderId": "086",
              "reminderName": "已知檢查當日若有息肉切片，為避免出血，健檢完三天內不可搭乘飛機"
            }
          ]
        },
        {
          "groupId": "GI08",
          "groupName": "眼底斷層掃描檢前提醒",
          "examItem": "LB0007000M",
          "examName": "眼底斷層掃描",
          "reminderInfos": [
            {
              "reminderId": "101",
              "reminderName": "檢查前請勿配戴隱形眼鏡，並攜帶眼鏡以備檢查後使用"
            },
            {
              "reminderId": "102",
              "reminderName": "檢查後短暫視力模糊屬正常現象，請勿自行駕車"
            }
          ]
        }
      ],
      "bookingInfo": {
        "checkupDate": {
          "bookDate": "20250601",
          "bookTime": "0900"
        },
        "nutrition": {
          "bookDate": "20250601",
          "bookTime": "1100"
        },
        "imaging": {
          "bookDate": "20250601",
          "bookTime": "1300"
        },
        "imagingContact": "0912345678",
        "orgName": "敦南中心",
        "orgAddress": "台北市大安區敦化南路二段333號2樓",
        "contactAddress": "台北市大安區光復南路102號13F",
        "deliveryMethod": "01",
        "deliveryAddress": "台北市大安區光復南路102號13F",
        "language": "中文",
        "clothesSize": "L",
        "breakfast": "中式/素食",
        "lunch": "中式/素食"
      },
      "packageGroup": {
        "selfAmt": "18500",
        "dayType": "2",
        "packageName": "全方位健檢",
        "packageDetail": {
          "packageList": [
            {
              "deptName": "一般檢查",
              "deptEName": "General Examination",
              "examInfo": [
                {
                  "examName": "身體組成分析",
                  "examItem": "PE00010040"
                },
                {
                  "examName": "身高",
                  "examItem": "PE00010001"
                },
                {
                  "examName": "體重",
                  "examItem": "PE00010002"
                },
                {
                  "examName": "身體質量指數",
                  "examItem": "PE00010006"
                },
                {
                  "examName": "理想體重",
                  "examItem": "PE00010003"
                },
                {
                  "examName": "脈搏",
                  "examItem": "PE00010007A"
                },
                {
                  "examName": "血壓",
                  "examItem": "PE00010009A"
                },
                {
                  "examName": "腰圍",
                  "examItem": "PE00010017"
                }
              ]
            },
            {
              "deptName": "心血管及代謝系統",
              "deptEName": "Cardiovascular and Metabolic System",
              "examInfo": [
                {
                  "examName": "總膽固醇",
                  "examItem": "L3001900"
                },
                {
                  "examName": "三酸甘油脂",
                  "examItem": "L3002000"
                }
              ]
            },
            {
              "deptName": "腫瘤標記",
              "deptEName": "Tumor Marker",
              "examInfo": [
                {
                  "examName": "癌胚胎抗原",
                  "examItem": "LI001600"
                },
                {
                  "examName": "鱗狀細胞癌抗原",
                  "examItem": "LI005200"
                }
              ]
            }
          ],
          "addList": [
            {
              "examItem": "PE000001A",
              "examName": "眼底斷層掃描"
            },
            {
              "examItem": "R401470005",
              "examName": "十年心血管疾病風險評估"
            },
            {
              "examItem": "PE00010006",
              "examName": "身體質量指數"
            }
          ]
        }
      }
    },
    "timestamp": "2025-06-02T13:00:00Z"
  },
  "cancelappointmentinfo": {
    "success": true,
    "statusCode": "S0000",
    "data": {},
    "timestamp": "2025-04-27T13:40:00Z"
  }
}
